import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { environment } from '../../../environments/environment';

/** Причината в `/login?reason=…`, когато API-то е отхвърлило сесията (#399). */
export const SESSION_ENDED_REASON = 'session-ended';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!req.url.startsWith(environment.apiUrl)) return next(req);

  return from(auth.getAccessToken()).pipe(
    switchMap((token) => {
      // Без токен няма сесия за приключване — 401 тук не води никъде (няма цикъл).
      if (!token) return next(req);
      return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })).pipe(
        catchError((err: unknown) => {
          // API-то отхвърли токена на влезлия потребител — например достъпът
          // му е премахнат (#399). Сесията се приключва веднъж, после вход.
          if (err instanceof HttpErrorResponse && err.status === 401 && auth.endRejectedSession()) {
            void router.navigate(['/login'], { queryParams: { reason: SESSION_ENDED_REASON } });
          }
          return throwError(() => err);
        }),
      );
    }),
  );
};
